import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { LANGUAGE, translate } from "services/general";
import { user } from "services/user";
import NavDivider from "./NavDivider";

/**
 * Top-bar identity block (top-bar design): avatar + name + role as a single
 * profile entry point, followed by a red-toned logout affordance. The settings
 * ("appearance") entry now lives in the tools cluster, so it is no longer here.
 */
const NavbarProfileActions = ({ isDark, handelLogout }) => {
  const { t } = useTranslation();

  const fullName = `${translate(user?.fname, user?.en_fname) || ""} ${
    translate(user?.lname, user?.en_lname) || ""
  }`.trim();
  const role = user?.roles?.[0]?.name;
  const initial = fullName ? fullName.charAt(0) : "?";

  return (
    <div className="flex items-center gap-1 lg:gap-2 shrink-0">
      <NavDivider isDark={isDark} />

      <Tooltip title={t("pages.profile")}>
        <Link
          to={`/${LANGUAGE}/profile`}
          className={`flex items-center gap-2 p-1 lg:pe-2 rounded-full transition-colors ${
            isDark ? "hover:bg-white/[0.08]" : "hover:bg-surface-muted"
          }`}
        >
          {user?.photo_url ? (
            <img
              src={user.photo_url}
              alt={fullName || "User avatar"}
              className="h-9 w-9 rounded-full object-cover"
            />
          ) : (
            <span className="h-9 w-9 rounded-full bg-gradient-to-br from-primary to-[#43c3da] text-white text-sm font-bold flex items-center justify-center uppercase">
              {initial}
            </span>
          )}
          <span className="hidden xl:flex flex-col items-start leading-tight text-start max-w-[140px]">
            <span
              className={`text-[13px] font-bold truncate max-w-full ${
                isDark ? "text-white" : "text-heading"
              }`}
            >
              {fullName || t("pages.profile")}
            </span>
            {role && (
              <span
                className={`text-[11px] truncate max-w-full ${
                  isDark ? "text-white/55" : "text-text-muted"
                }`}
              >
                {role}
              </span>
            )}
          </span>
        </Link>
      </Tooltip>

      <Tooltip title={t("logout")}>
        <button
          type="button"
          onClick={handelLogout}
          className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors shrink-0 ${
            isDark
              ? "bg-danger/20 text-[#ff8a8c] hover:bg-danger/30 hover:text-white"
              : "text-secondary hover:bg-danger-bg-soft hover:text-danger"
          }`}
        >
          <FontAwesomeIcon icon={faRightFromBracket} className="text-[18px]" />
        </button>
      </Tooltip>
    </div>
  );
};

export default NavbarProfileActions;
